import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreferredRoleComponent } from './preferred-role.component';
import { VerificationStatusModule } from "../../components/verification-status/verification-status.module";



@NgModule({
  declarations: [PreferredRoleComponent],
  imports: [
    CommonModule,
    VerificationStatusModule,
  ],
  exports: [
    PreferredRoleComponent
  ]
})
export class PreferredRoleModule { }
